module.exports = __webpack_public_path__ + "static/media/arrowBlackBottom.716a66f1.svg";